import { Col, Row, Form, Button } from 'react-bootstrap';
import { useState, useCallback, useEffect } from 'react';

import TagButton from '../common/tag-button';
import BasicSpinner from '../common/basic-spinner';
import { formatTagsJSON } from '../../utils/utils';

//================================================================

export default function UpdateFormTags({object, onChange, disabled}){

  const [tagDisplay, setTagDisplay] = useState(object.tags);
  const [tagsToRemove, setTagsToRemove] = useState([]);
  const [tagsToAdd, setTagsToAdd] = useState([]);
  const [working, setWorking] = useState(disabled);

  useEffect(() => {
    setTagDisplay(object.tags);
  },[object]);

  useEffect(() => {
    onChange({
      'add_tags' : tagsToAdd,
      'remove_tags' : tagsToRemove
    });
  },[tagsToRemove, tagsToAdd])

  const addTagToRemove = useCallback((tag) => {
    const copy = tagsToRemove.slice();
    copy.push(tag);
    copy.filter(e => e);
    setTagsToRemove([...new Set(copy)]);
  }, [tagsToRemove]);

  const removeTagToRemove = useCallback((tag) => {
    const copy = tagsToRemove.slice();
    const index = tagsToRemove.findIndex(e => e === tag );
    if (index >= 0) copy.splice(index, 1);
    copy.filter(e => e);
    setTagsToRemove([...new Set(copy)]);
  }, [tagsToRemove]);

  const updateTagsToAdd = (tagString) => {
    setTagsToAdd(formatTagsJSON(tagString));
  };

  return(
    <Form.Group className="mb-4">
      <Form.Label>Tags</Form.Label>
      <Row className="g-1 justify-content-start mb-2">
        {tagDisplay.map((tag,index) => 
          <TagButton
            key={`${index}-${tag}`}
            tag={tag}
            disabled={working}
            onSelect={addTagToRemove}
            onDeselect={removeTagToRemove}
          />
        )}
        <Form.Text className="text-muted">
          Remove selected tags.
        </Form.Text>
      </Row>
      <Row className="g-0 justify-content-between">
        <Col className="col-10 text-start">
          <Form.Control
            // value={tagString}
            type="text"
            placeholder="Enter tags to add"
            onChange={(event) => updateTagsToAdd(event.target.value)}
            disabled={working}
          />
          <Form.Text className="text-muted">
            Separate tags using commas.
          </Form.Text>
        </Col>
      </Row>
    </Form.Group>
  );
}
